import {
  HomeIcon,
  PhoneIcon,
  ChartBarIcon,
  CogIcon,
  ArrowTrendingUpIcon,
  ArrowTrendingDownIcon,
  MinusIcon
} from '@heroicons/react/24/outline';

// Navigation icons mapping
export const navigationIcons = {
  dashboard: HomeIcon,
  callLogs: PhoneIcon,
  analytics: ChartBarIcon,
  resources: CogIcon,
  settings: CogIcon
} as const;

// Trend indicator icons
export const trendIcons = {
  up: ArrowTrendingUpIcon,
  down: ArrowTrendingDownIcon,
  neutral: MinusIcon
} as const;

export type NavigationIconKey = keyof typeof navigationIcons;
export type TrendIconKey = keyof typeof trendIcons;